import React, { useEffect, useState, useContext } from 'react'
import { withStyles } from '@material-ui/core/styles'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import cn from 'classnames'
import ModifyingInfoModal from 'Components/EditOrder/comps/ModifyingInfoModal.component'
import PageTip from 'Components/PageTip/PageTip.component'
import { Grid, Typography } from '@material-ui/core'
import { Order } from 'types/Order'
import { useDispatch } from 'react-redux'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_EDIT_ORDER_MODAL_OPEN_TERMS } from 'State/Store/UI/UI.types'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import EditOrderModalStyles from '../EditOrderModal.styles'
import { EditOrderForm } from './Step2.EditOrderForm'

export type EditOrderChangingItem = {
  fieldKey: keyof EditOrderForm,
  label: string,
  formattedValue: string,
  tip?: any,
}

interface Props {
  classes: any,
  changingItems: EditOrderChangingItem[],
  order: Order,
}

const EditOrderStep3Comp = (props: Props) => {
  const {
    classes,
    changingItems = [],
    order,
  } = props
  const dispatch = useDispatch()
  const [infoModalOpen, setInfoModalOpen] = useState(false)

  const reportOpenTCs = () => {
    dispatch(hitGTM(UI_EDIT_ORDER_MODAL_OPEN_TERMS))
  }

  const row = (fieldKey: keyof EditOrderForm, label: string, content: string | React.ReactNode, tip?: any) => {
    return (
      <React.Fragment key={fieldKey}>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography className={classes.row} variant='overline'>
              {label}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant='overline' className={classes.fontWeight500} data-mf-replace-inner={MFSDR}>
              {content}
            </Typography>
          </Grid>
        </Grid>
        {tip &&
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {tip}
          </Grid>
        </Grid>}
      </React.Fragment>
    )
  }

  const editTopContent = (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12} className={cn(classes.marginTop3unit)}>
        <PageTip alignItems="flex-start"
          content={
            <Typography variant="body2" className={classes.toolTipContent}>Your changes have not yet been submitted.</Typography>
          }
        />
      </Grid>
    </Grid>
  );
  return (
    <React.Fragment>
      {editTopContent}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          { changingItems.map((item) => {
            const { fieldKey, label, formattedValue, tip } = item
            return row(fieldKey, label, formattedValue, tip)
          })}
          <hr className={classes.separator} />
          <Typography variant='body2' className={cn(classes.note, classes.row)}>
            { `By modifying your order through Boral Connects you agree to the ` }
            <a
              onClick={reportOpenTCs}
              rel='noopener noreferrer'
              target='_blank'
              className={classes.hyperlink}
              href='https://www.boral.com.au/products/concrete/terms_quotation_supply'
            >
              { `Concrete Terms of Quotation & Supply` }
            </a>
          </Typography>
        </Grid>
      </Grid>
      <ModifyingInfoModal
        shouldHideSwitch
        showOkBtnOnly
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
      />
    </React.Fragment>
  )
}


const EditOrderStep3 = withStyles(themeCreateInjectableStyles(EditOrderModalStyles) as any, { withTheme: true })(EditOrderStep3Comp)
export default EditOrderStep3
